// src/pages/Sidebar/index.jsx
// 侧边栏
import React, {useRef, useEffect, useMemo, useState} from 'react';
import './index.less';
import {Dropdown, message as antdMessage} from 'antd';
import userAvatar from "@/assets/img/img_tx@2x.png";
import imgZwltjl from "@/assets/img/img_zwltjl@2x.png";
import iconQwzy from "@/assets/img/icon_qwzy@2x.png";
import imgGoldVip from "@/assets/img/icon_vip_gold.png";
import imgSliverVip from "@/assets/img/icon_vip_sliver.png";
import imgGoldExpired from "@/assets/img/icon_not_vip_gold.png";
import imgSliverExpired from "@/assets/img/icon_not_vip_sliver.png";
import {DeleteOutlined} from '@ant-design/icons';
import {getValidLoginId} from '@/utils/auth';
import {STATUS_KEY, USER_ID_KEY} from "../../utils/auth";
import deleteImg from "@/assets/img/icon_history_deleted.png"

const Sidebar = ({
                     goLogin,
                     isOpen,
                     onClose,
                     historyList,
                     onSelectHistory,
                     onNewChat,
                     hasHistory,
                     onLoadMore,
                     isFetchingMore,
                     hasMore,
                     onDeleteSession,
                     displayUsername,
                     onGoMyPage,
                     isVisitor,
                     vipInfo,
                     onRenewVip,
                     activeSessionId,
                 }) => {
    const scrollRef = useRef(null);
    const longPressTimer = useRef(null); //长按计时器引用
    const [openId, setOpenId] = useState(null); //控制哪一个 Dropdown 打开
    const touchStartPosRef = useRef({x: 0, y: 0});

    const vipMeta = useMemo(() => {
        const rawStatus = String(
            vipInfo?.memberStatus || vipInfo?.status || vipInfo?.vipStatus || "",
        ).toLowerCase();
        const rawLevel = String(vipInfo?.memberLevel || "").toLowerCase();
        const expireTime = vipInfo?.expireTime || vipInfo?.endTime || "";
        const expireDate = expireTime ? new Date(expireTime) : null;
        const hasExpiredByDate =
            expireDate instanceof Date &&
            !Number.isNaN(expireDate.getTime()) &&
            expireDate.getTime() <= Date.now();
        const isActiveVip =
            rawStatus === "active" && !hasExpiredByDate;
        const isExpired =
            vipInfo?.expired === true ||
            !isActiveVip ||
            rawStatus === "expired" ||
            rawStatus === "gq" ||
            rawStatus === "0";
        const formatDate = (value) => {
            if (!value) return "";
            const date = new Date(value);
            if (Number.isNaN(date.getTime())) return "";
            const year = String(date.getFullYear()).slice(-2);
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}.${month}.${day}`;
        };
        const vipStatusContent = (vipInfo) => {
            if((vipInfo.status !== "ACTIVE" && vipInfo.status !== "EXPIRED") || vipInfo.status === "NOT_OPENED") {
                return "未开通"
            } else if(vipInfo.expiredDays > 0 || vipInfo.status === "EXPIRED") {
                return "已过期"
            } else {
                return `还剩 ${vipInfo.remainingDays || ""} 天到期`
            }
        }

        const formattedExpireDate = formatDate(expireTime);
        const expireText = vipStatusContent(vipInfo)
        return {
            isExpired,
            expireText,
            badge: isExpired ? rawLevel === "gold" ? imgGoldExpired : imgSliverExpired : rawLevel === "gold" ? imgGoldVip : imgSliverVip,
        };
    }, [vipInfo]);

    const handleRenewVip = (e) => {
        e.stopPropagation();
        if (onRenewVip) {
            onRenewVip();
            return;
        }
        antdMessage.info("续费功能正在接入中，敬请期待~");
    };

    useEffect(() => {
        if (isOpen && hasMore && !isFetchingMore && scrollRef.current) {
            const {scrollHeight, clientHeight} = scrollRef.current;
            // 如果没有产生滚动条（内容高度 <= 容器高度），且后端还有数据，自动加载下一页
            if (scrollHeight > 0 && scrollHeight <= clientHeight) {
                console.log("检测到内容不满屏，自动加载下一页...");
                onLoadMore();
            }
        }
    }, [isOpen, historyList, hasMore, isFetchingMore]);
    // 处理长按逻辑 - 开始计时
    const handleTouchStart = (e, itemId) => {
        // 记录初始位置
        const touch = e.touches[0];
        touchStartPosRef.current = {x: touch.clientX, y: touch.clientY};

        // 开启计时器
        longPressTimer.current = setTimeout(() => {
            // 【关键优化点】：计时器到时间即刻显示，无需等待松手
            setOpenId(itemId);

            // 增加震动反馈（真机支持，提升触感）
            if (window.navigator.vibrate) {
                window.navigator.vibrate(40);
            }
        }, 600); // 建议 600ms，比之前稍快，体验更灵敏
    };
    // 2. 处理触摸移动（防止滚动时误触发）
    const handleTouchMove = (e) => {
        if (!longPressTimer.current) return;

        const touch = e.touches[0];
        const deltaX = Math.abs(touch.clientX - touchStartPosRef.current.x);
        const deltaY = Math.abs(touch.clientY - touchStartPosRef.current.y);

        // 如果移动距离超过 10px，判定为滚动或拖拽，立即取消长按计时
        if (deltaX > 10 || deltaY > 10) {
            clearTimeout(longPressTimer.current);
            longPressTimer.current = null;
        }
    };

    // 处理长按逻辑 - 提前结束（用户松手或移动）
    const handleTouchEnd = () => {
        if (longPressTimer.current) {
            clearTimeout(longPressTimer.current);
            longPressTimer.current = null;
        }
    };

    const handleScroll = (e) => {
        const {scrollTop, scrollHeight, clientHeight} = e.currentTarget;
        // 触底检测：距离底部 30px 触发
        if (scrollHeight - scrollTop <= clientHeight + 30) {
            onLoadMore();
        }
    };

    const renderHistoryContent = () => {
        // 检查分类对象是否为空
        // if (!localStorage.getItem(USER_ID_KEY)) {
        //     return (
        //         <div className="empty-history-wrapper">
        //             <div className="empty-main-content">
        //                 <span className="hint-text">您还没有</span>
        //                 <span style={{color: "#5B69FC"}} className="hint-text"
        //                       onClick={goLogin}>登录</span>
        //             </div>
        //         </div>
        //     );
        // }
        const isLoginExpired = !isVisitor && !getValidLoginId();
        if (isLoginExpired) {
            return (
                <div className="empty-history-wrapper">
                    <div className="empty-main-content">
                        <p className="hint-text">登录已过期，请重新登录</p>
                    </div>
                </div>
            );
        }
        const categories = Object.keys(historyList || {});
        const isEmpty = !hasHistory || categories.length === 0;

        if (isEmpty) {
            return (
                <div className="empty-history-wrapper">
                    <div className="empty-main-content">
                        <img src={imgZwltjl} alt="no-history" className="main-illustration"/>
                        <p className="hint-text">还没有对话记录</p>
                    </div>
                    <div className="empty-action-area">
                        <button className="new-consult-btn" onClick={() => {
                            onNewChat();
                            onClose();
                        }}>
                            <span>开启新咨询</span>
                            <img src={iconQwzy} alt="arrow" className="btn-arrow"/>
                        </button>
                    </div>
                </div>
            );
        }
        const menuItems = [
            {
                label: '删除对话',
                key: 'delete',
                danger: true,
                icon: <DeleteOutlined/>,
            },
        ];

        // 按分类渲染
        return (
            <div
                className="history-list-container"
                ref={scrollRef}
                onScroll={handleScroll}
            >
                {categories.map((category) => {
                    const items = historyList[category];
                    if (!items || items.length === 0) return null;
                    return (
                        <div key={category} className="history-category-group">
                            <div className="category-label">{category}</div>
                            <div className="history-items">
                                {items.map((item) => (
                                    <Dropdown
                                        key={item.id}
                                        menu={{
                                            items: menuItems,
                                            onClick: (e) => {
                                                e.domEvent.stopPropagation();
                                                onDeleteSession(item);
                                                setOpenId(null);
                                            }
                                        }}
                                        // trigger={['contextMenu']} // 兼容 PC 右键
                                        placement="bottom"
                                        open={openId === item.id}  // 响应式控制
                                        onOpenChange={(visible) => !visible && setOpenId(null)}
                                    >
                                        <div
                                            className={`history-item ${openId === item.id ? 'is-pressing' : ''} ${activeSessionId === item.id ? 'is-active' : ''}`}
                                            onClick={() => !openId && onSelectHistory(item)}
                                            // 移动端兼容逻辑
                                            onTouchStart={(e) => handleTouchStart(e, item.id)}
                                            onTouchMove={handleTouchMove}
                                            onTouchEnd={handleTouchEnd}

                                            // 【修改点 3】：兼容 PC 端的右键操作
                                            onContextMenu={(e) => {
                                                e.preventDefault(); // 阻止系统默认菜单
                                                setOpenId(item.id); // 立即打开我们预设位置的 Dropdown
                                            }}
                                        >
                    <span className="item-text">
                      {item.sessionIntent || item.userInput || "无标题对话"}
                    </span>
                    <span className="item-delete" onClick={(e) => {
                        e.stopPropagation();
                        onDeleteSession(item);
                    }}>
                        <img className="deleted-icon" src={deleteImg} alt=""/>
                    </span>
                                        </div>
                                    </Dropdown>
                                ))}
                            </div>
                        </div>
                    );
                })}
                {/* 加载状态提示 */}
                {isFetchingMore && <div className="loading-more">正在加载...</div>}
                {!hasMore && categories.length > 0 && <div className="no-more">已显示全部记录</div>}
            </div>
        );
    };

    return (
        <>
            <div className={`sidebar-mask ${isOpen ? 'show' : ''}`} onClick={onClose}/>
            <div className={`sidebar-wrapper ${isOpen ? 'open' : ''}`}>
                <div className="sidebar-header-section">
                    <div className="user-profile">
                        <img src={userAvatar} alt="avatar" className="avatar"/>
                        <div className="user-meta">
                            <div className="username-row">
                                <span className="username">{displayUsername}</span>
                                {
                                    localStorage.getItem(STATUS_KEY) == "logged_in" &&
                                    <img
                                        src={vipMeta.badge}
                                        alt=""
                                        className="vip-badge"
                                    />
                                }
                            </div>
                            <div className="vip-row">
                                <span className="vip-expire-text">{vipMeta.expireText}</span>
                                {
                                    localStorage.getItem(STATUS_KEY) == "logged_in" &&
                                    <button className="renew-btn" type="button" onClick={handleRenewVip}>
                                        {(vipInfo.memberStatus !== "ACTIVE" && vipInfo.memberStatus !== "EXPIRED") || vipInfo.memberStatus === "NOT_OPENED"
                                            ? "开通会员" : "去续费"}
                                    </button>
                                }
                            </div>
                        </div>
                        {
                            // localStorage.getItem(STATUS_KEY) == "logged_in" &&
                            <button className="go-home" type="button" onClick={() => {
                                onGoMyPage();
                                onClose();
                            }}>
                                我的主页 &gt;
                            </button>
                        }
                    </div>
                </div>

                <div className="sidebar-main-body">
                    <h2 className="sidebar-title">对话记录</h2>
                    <div className="content-viewport">
                        {renderHistoryContent()}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Sidebar;
